<template>
  <v-col cols="12 pa-0">
    <span>Строк на странице:</span>
    <v-select
      v-model="selected"
      @input="onSelectedChanged"
      :items="items"
      hide-details
      dense
      class="d-inline-flex pa-2 v-select-shrinked"
      :itemColor="$store.getters['settings/dark'] ? 'white' : 'black'"
    ></v-select>
  </v-col>
</template>

<script>
export default {
  props: ['value'],

  data: () => ({
    items: [10, 15, 20, 30, 50],
    selected: Number
  }),

  watch: {
    value: function (val) {
      // сохраняем в localStorage
      localStorage.setItem('rows', val)
      this.selected = val
    }
  },

  methods: {
    onSelectedChanged (val) {
      // сохраняем в localStorage
      localStorage.setItem('rows', val)
      // событие для родителя
      this.$emit('input', val)
    }
  },

  created () {
    this.selected = parseInt(localStorage.getItem('rows') ?? this.items[1])
    this.$emit('input', this.selected)
  }
}
</script>
